import { useContext, useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { MyContext } from '../Context/MyProvider';
import Logo from "../image/astrotalk-logo.png";
import PlayLogo from "../image/PlayStore.png";
import AppLogo from "../image/AppStore.png";
import { useTranslation } from 'react-i18next';

const Footer = () => {
    const { t } = useTranslation();
    const { HandleCallApi } = useContext(MyContext);

    const [pageList, setPageList] = useState([]);
    const GetDate = new Date();
    const PageListRef = useRef(false);

    useEffect(() => {
        handleGetPageList();
    }, []);

    const handleGetPageList = async () => {
        if (PageListRef.current) return;
        PageListRef.current = true;
        const Response = await HandleCallApi("Get", "user/pages");
        setPageList(Response?.data?.pages_data);
    }

    return (
        <footer className="modern_footer">
            <div className="width_container">
                <div className="footer_grid">
                    
                    {/* Column 1: Brand & Bio */}
                    <div className="footer_column">
                        <div className="flex items-center gap-3">
                            <img src={Logo} className="w-[45px] h-[45px] rounded-full border border-orange-500/30" alt="Logo" />
                            <Link to="/" className="text-[26px] font-bold text-white tracking-wide hover:text-[#FA6400] transition-colors">AstroSpace</Link>
                        </div>
                        <p className="footer_brand_desc mt-2">
                            {t("Empowering your life journey with Vedic wisdom, celestial insights, and professional astrology guides. Your destiny, unlocked.")}
                        </p>
                        
                        {/* Trust Badges */}
                        <div className="trust_badges">
                            <div className="trust_item">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="trust_icon"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path><path d="m9 11 2 2 4-4"></path></svg>
                                <span>{t("100% Verified Astrologers")}</span>
                            </div>
                            <div className="trust_item">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="trust_icon"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>
                                <span>{t("Secure & Encrypted Payments")}</span>
                            </div>
                        </div>
                    </div>

                    {/* Column 2: Quick Navigation */}
                    <div className="footer_column">
                        <h3 className="footer_title">{t("Services")}</h3>
                        <ul className="footer_links">
                            <li className="footer_link_item">
                                <Link to="/chat-width-astrologer">{t("Chat with Astrologer")}</Link>
                            </li>
                            <li className="footer_link_item">
                                <Link to="/kundli-matching">{t("Kundli Matching")}</Link>
                            </li>
                            <li className="footer_link_item">
                                <Link to="/freekundli">{t("Free Kundli")}</Link>
                            </li>
                            <li className="footer_link_item">
                                <Link to="/horoscope">{t("Daily Horoscope")}</Link>
                            </li>
                        </ul>
                    </div>

                    {/* Column 3: Company / Useful Pages */}
                    <div className="footer_column">
                        <h3 className="footer_title">{t("Useful Links")}</h3>
                        <ul className="footer_links">
                            {pageList?.map((item, index) => {
                                const Title = item.title.replace(/\s+/g, '-').toLowerCase();
                                return (
                                    <li key={index} className="footer_link_item">
                                        <Link to={`/pages/${Title}`}>{item.title}</Link>
                                    </li>
                                );
                            })}
                            <li className="footer_link_item">
                                <Link to="/recent-post">{t("Recent Posts")}</Link>
                            </li>
                        </ul>
                    </div>

                    {/* Column 4: App downloads & Connect */}
                    <div className="footer_column">
                        <h3 className="footer_title">{t("Connect With Us")}</h3>
                        
                        {/* App Downloads */}
                        <div className="badge_container">
                            <Link to="https://play.google.com/" className="download_badge">
                                <img src={PlayLogo} className="w-[140px] block" alt="PlayStore" />
                            </Link>
                            <Link to="https://apps.apple.com/" className="download_badge">
                                <img src={AppLogo} className="w-[140px] block" alt="AppStore" />
                            </Link>
                        </div>

                        {/* Social Media Links */}
                        <div className="social_container">
                            <a href="https://facebook.com/" target="_blank" rel="noopener noreferrer" className="social_icon_btn" aria-label="Facebook">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path></svg>
                            </a>
                            <a href="https://instagram.com/" target="_blank" rel="noopener noreferrer" className="social_icon_btn" aria-label="Instagram">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line></svg>
                            </a>
                            <a href="https://linkedin.com/" target="_blank" rel="noopener noreferrer" className="social_icon_btn" aria-label="LinkedIn">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path><rect x="2" y="9" width="4" height="12"></rect><circle cx="4" cy="4" r="2"></circle></svg>
                            </a>
                            <a href="https://twitter.com/" target="_blank" rel="noopener noreferrer" className="social_icon_btn" aria-label="Twitter">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z"></path></svg>
                            </a>
                            <a href="https://youtube.com/" target="_blank" rel="noopener noreferrer" className="social_icon_btn" aria-label="YouTube">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z"></path><polygon points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02"></polygon></svg>
                            </a>
                        </div>
                    </div>

                </div>

                <div className="footer_divider"></div>

                {/* Bottom Row */}
                <div className="footer_bottom">
                    <p>© {GetDate.getFullYear()} AstroSpace. All rights reserved.</p>
                    <div className="footer_bottom_links">
                        <Link to="/pages/privacy-policy">{t("Privacy Policy")}</Link>
                        <Link to="/pages/terms-conditions">{t("Terms of Service")}</Link>
                        <Link to="#cookies">{t("Cookie Settings")}</Link>
                    </div>
                </div>

            </div>
        </footer>
    );
};

export default Footer;